import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useEffect, useState } from 'react';

interface VSelectDatumProps {
    handleChangeSelect: (event: SelectChangeEvent) => void;
    initValue?: string;
    required?: boolean; 
}

export const VSelectDatum = ({ handleChangeSelect, initValue, required }: VSelectDatumProps) => {

    const [value, setValue] = useState<string>('');

    useEffect(() => {
        if (initValue) {
            setValue(initValue);
        }
    }, [initValue]);

    const labelText = required ? 'Datum *' : 'Datum';

    return (
        <FormControl fullWidth>
            <InputLabel id='select_company'>{labelText}</InputLabel>
            <Select
                labelId='select_company'
                id='select_company'
                value={value}
                label={labelText} 
                onChange={handleChangeSelect}
            >

                <MenuItem value='SIRGAS2000'>SIRGAS2000</MenuItem>
                <MenuItem value='WGS 84'>WGS 84</MenuItem>
                <MenuItem value='SAD 69'>SAD 69</MenuItem>
            </Select>
        </FormControl>
    );
};